import { msg } from '@lingui/core/macro'
import { Trans, useLingui } from '@lingui/react/macro'
import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '~/components/settings/settings-page'
import { StatusCatalogEditor } from '~/components/settings/status-catalog-editor'
import { titleFor } from '~/lib/route-title'
import { useWorkspace } from '~/lib/workspace-context'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/settings/statuses')({
  component: StatusesSettings,
  head: () => ({ meta: [{ title: titleFor(msg`Statuses`) }] }),
})

/** Status categories remain immutable because board behavior keys off them. */
function StatusesSettings() {
  const { t } = useLingui()
  const isAdmin = useWorkspace().role === 'admin'

  return (
    <SettingsPage>
      {!isAdmin && (
        <p className="text-muted-foreground text-sm">
          <Trans>Only workspace admins can change statuses.</Trans>
        </p>
      )}
      <StatusCatalogEditor description={null} kind="task" title={t`Task statuses`} />
      <StatusCatalogEditor description={null} kind="project" title={t`Project statuses`} />
    </SettingsPage>
  )
}
